import {Injectable} from '@angular/core'
import {ApiService} from "../api/api.service";

import {map} from "rxjs/operators";
import {Observable, shareReplay, takeUntil, timer} from "rxjs";
import {Backend} from "@generated-backend-types";
import TableConfig = Backend.App.Resources.Dashboard.Meta.TableConfig;

@Injectable({providedIn: 'root'})
export class TablesService extends ApiService {
  protected endpoint = '/meta/table-config';

  private cacheExpiryTimeForGetRequests = 10000; // 10 seconds
  private cachedTableConfig?: { result: Observable<TableConfig[]>, cachedAt: number };

  public getConfigurationForTable(tableId: string, withoutCache = false): Observable<TableConfig| undefined> {
    const cachedResult = this.cachedTableConfig;

    if (!withoutCache && cachedResult && cachedResult.cachedAt > Date.now() - this.cacheExpiryTimeForGetRequests) {
      return cachedResult.result.pipe(map(t => t.find(t => t.id === tableId)));
    }
    this.cachedTableConfig = undefined;

    const result = this.http.get<TableConfig[]>(this.endpoint).pipe(
      takeUntil(timer(this.cacheExpiryTimeForGetRequests)),
      shareReplay(1),
    );

    this.cachedTableConfig = {result, cachedAt: Date.now()};
    return result.pipe(map(t => t.find(t => t.id === tableId)));
  }
}
